import { memo } from 'react';
import type { TagWrapperProps as Props } from './types';
import * as Styled from './styles';
import { ensureArray } from '@aibees/elephant/feature/suggestion-search-bar/utils';
import { OptionTag } from '@aibees/elephant/feature/suggestion-search-bar/components/option-tag';

export const TagWrapper = memo(({ className, value, onDelete }: Props) => {
  return (
    <Styled.Wrapper>
      {value.map((option, index) => (
        <OptionTag
          key={`${option.value}-${index}`}
          label={option.label}
          logoUrl={option.logo}
          onDelete={() => {}}
          extraDeleteAction={() => onDelete?.(option, ensureArray(value))}
        />
      ))}
    </Styled.Wrapper>
  );
});

TagWrapper.displayName = 'TagWrapper';
